<script>
import { WALLET_EMPTY_MESSAGE } from '@modules/consolidator/constants/Text'
import { filterChartToConsolidatedOnly } from '@modules/consolidator/utils/format-rentability-chart/format-rentability-chart'
import { chartHasNoData } from '@modules/consolidator/utils/chart-has-no-data/chart-has-no-data'
import FeedbackWrapper from '@modules/global/components/feedback-wrapper/feedback-wrapper.vue'
import RentabilidadeChart from '@modules/consolidator/components/rentabilidade-chart/rentabilidade-chart.vue'
import BenchmarksMenu from '@modules/consolidator/components/benchmarks-menu/benchmarks-menu.vue'

export default {
  name: 'PortfolioBenchmark',
  components: {
    FeedbackWrapper,
    RentabilidadeChart,
    BenchmarksMenu,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasAssetsAutomatic: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    benchmarks: {
      type: Array,
      default: () => [],
    },
    clienteBenchmarkMeta: {
      type: Object,
      default: null,
    },
    availableBenchmarkNames: {
      type: Set,
      default: () => new Set(),
    },
    showAddBenchmark: {
      type: Boolean,
      default: false,
    },
    hideBenchmarks: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: WALLET_EMPTY_MESSAGE,
    },
  },
  data() {
    return {
      showAllGroups: false,
    }
  },
  computed: {
    displayedData() {
      if (!this.data) return this.data
      if (this.showAllGroups) return this.data
      return filterChartToConsolidatedOnly(this.data)
    },
    hasNoData() {
      return chartHasNoData(this.displayedData)
    },
    selectedBenchmarksProxy: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    onShowAllGroups(newValue) {
      this.showAllGroups = newValue
      this.$emit('update:showAllGroups', newValue)
    },
  },
}
</script>

<template>
  <div
    class="portfolio-benchmark az-card-bordered"
    :class="{ 'portfolio-benchmark--loading': loading }"
  >
    <div v-if="!loading" class="portfolio-benchmark__header">
      <div
        class="portfolio-benchmark__title az-ds-card-title"
      >
        Portfólio e Benchmark
      </div>
      <div class="portfolio-benchmark__actions">
        <div class="portfolio-benchmark__actions-left">
          <slot name="actions-left"></slot>
        </div>

        <div
          class="portfolio-benchmark__actions-right"
          :class="{
            'portfolio-benchmark__actions-right--compact': hideBenchmarks,
          }"
        >
          <div class="portfolio-benchmark__action-rentabilidade">
            <BaseButton
              secondary
              text
              sm
              @click="onShowAllGroups(!showAllGroups)"
            >
              <icon-svg
                :name="
                  showAllGroups
                    ? 'mdi-checkbox-marked'
                    : 'mdi-checkbox-blank-outline'
                "
                :size="16"
                color="primary"
              />
              Mostrar todos os grupos
            </BaseButton>
            <BenchmarksMenu
              v-if="!hideBenchmarks"
              v-model="selectedBenchmarksProxy"
              :benchmarks="benchmarks"
              :cliente-benchmark-meta="clienteBenchmarkMeta"
              :available-benchmark-names="availableBenchmarkNames"
              :show-add-benchmark="showAddBenchmark"
              @change="$emit('change')"
              @add-benchmark="$emit('add-benchmark')"
              @reset="$emit('reset')"
            />
          </div>
          <slot name="actions-right"></slot>
        </div>
      </div>
    </div>

    <FeedbackWrapper
      :loading="loading"
      :noData="hasNoData"
      :message="emptyMessage"
    >
      <div class="portfolio-benchmark__content">
        <RentabilidadeChart :data="displayedData" />
      </div>
    </FeedbackWrapper>

    <slot v-if="!loading" name="footer"></slot>
  </div>
</template>

<style lang="sass">
.portfolio-benchmark
  padding-bottom: 32px

  &--loading
    padding: 0 !important

  @mixin flex-center($gap: 16px)
    display: flex
    align-items: center
    gap: $gap

  &__header
    @include flex-center(32px)
    align-items: flex-start
    margin-bottom: 16px
    flex-wrap: wrap
    justify-content: space-between

  &__actions
    @include flex-center(16px)
    justify-content: space-between
    flex: 1 1 auto
    min-width: 280px

    &-left
      @include flex-center
      flex: 1 1 auto
      min-width: 0

    &-right
      @include flex-center(2px)
      justify-content: space-between
      min-width: 260px

      // Sem o menu de benchmarks sobra um filho so, e o space-between numa
      // caixa de 260px o joga para a esquerda deixando o vao a direita.
      &--compact
        justify-content: flex-end
        min-width: 0

  &__title
    min-width: 180px

  &__action-rentabilidade
    display: flex
    align-items: center
    gap: 8px

    .v-menu--inline
      display: none

  &__content
    min-height: 450px
</style>
